import { render } from "./Dokumente.vue?vue&type=template&id=4a688c25&scoped=true"
import script from "./Dokumente.vue?vue&type=script&lang=js"
export * from "./Dokumente.vue?vue&type=script&lang=js"

import "./Dokumente.vue?vue&type=style&index=0&id=4a688c25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a688c25"]])

export default __exports__